import { gql } from '@apollo/client';

export const GET_HISTORY_NON_IFS_USERS = `query MyQuery($payload: STKFiltersVoucherInput ) {
    stkGetFilterVoucher(payload: $payload) {
        releasedVouchers {
            errorText
            flightLegNumber
            flightScheduledAt
            marketingCarrier
            groupId
            cabinId
            reasonId
            categoryId
            passengerEmailAddress
            passengerFirstName
            passengerLastName
            pnrLocator
            qty
            responseStatusCode
            voucherIds
            voucherIssuanceComment
            voucherIssuanceReason
            voucherStatusCode
            voucherSubTypeCode
            voucherTypeCode
            requestId

        },
        erroredVouchers {
            errorText
            flightLegNumber
            flightScheduledAt
            marketingCarrier
            groupId
            cabinId
            reasonId
            categoryId
            passengerEmailAddress
            passengerLastName
            passengerFirstName
            pnrLocator
            qty
            responseStatusCode
            voucherIds
            voucherIssuanceComment
            voucherIssuanceReason
            voucherStatusCode
            voucherSubTypeCode
            voucherTypeCode
            requestId

        },
        compensationRequests {
            errorText
            flightLegNumber
            flightScheduledAt
            marketingCarrier
            groupId
            cabinId
            reasonId
            categoryId
            passengerEmailAddress
            passengerLastName
            passengerFirstName
            pnrLocator
            qty
            responseStatusCode
            voucherIds
            voucherIssuanceComment
            voucherIssuanceReason
            voucherStatusCode
            voucherSubTypeCode
            voucherTypeCode
            requestId
        }
        errorNextPageToken
        requestNextPageToken
    }
}`;

export const GET_HISTORY_IFS_USERS = `query MyQuery {
    stkGetUserHistory {
        requestId
        errorText
        flightLegNumber
        flightScheduledAt
        marketingCarrier
        groupId
        cabinId
        reasonId
        categoryId
        passengerEmailAddress
        passengerFirstName
        passengerLastName
        pnrLocator
        qty
        responseStatusCode
        voucherIds
        voucherIssuanceComment
        voucherIssuanceReason
        voucherStatusCode
        voucherSubTypeCode
        voucherTypeCode
    }
}`;

export const GET_HISTORY_VOUCHER_CODES = `query MyQuery($voucherIds: [String]!) {
    getReleasedVoucherCode(voucherIds: $voucherIds) {
        errorText
        responseStatusCode
        voucherCode
        voucherId
        voucherSubTypeCode
        voucherTypeCode
    }
}`;

export const GET_VOUCHER_CODES = gql`
query MyQuery($requestId: String!, $voucherType:CodeType!) 
{
    requestStatusById(requestId: $requestId, voucherType: $voucherType) {  
           code,
           statusCode,
           message,
           data
        }
}
`;

// export const GET_VOUCHER_IDS = gql`
//     query MyQuery($voucherTypeCode: CodeType!, $voucherSubTypeCode: SubTypeCode, $count: Int) {
//         requestNewVouchers(count: $count, voucherTypeCode: $voucherTypeCode, voucherSubTypeCode: $voucherSubTypeCode) {
//             id
//         }
//     }
// `;

// export const GET_VOUCHER_IDS_FOR_NTP = gql`
//     query MyQuery($voucherTypeCode: CodeType!, $voucherSubTypeCode: SubTypeCode, $count: Int) {
//         requestNewVouchers(count: $count, voucherTypeCode: $voucherTypeCode, voucherSubTypeCode: $voucherSubTypeCode) {
//             id
//             voucherTypeCode
//             voucherSubTypeCode
//             updatedAt
//         }
//     }
// `;

export const GET_NOTIFICATIONS = `
    query MyQuery  {
        pactUserNotification    {
            notificationId
            notificationTitleEn
            notificationTitleFr
            notificationTextEn
            notificationTextFr
            notificationStartTime
            notificationEndTime
        }
    }
`;

export const GET_REASON_MASTER_DATA = `query GetReasonMasterData {
  getReasonMasterData {
    code
    message
    data {
      groups {
        groupId
        groupNameEn
        groupNameFr
      }
      reasons {
        reasonId
        reasonTitleEn
        reasonTitleFr
        groupIds
        shorthandTxt
        compensation
      }
      cabins {
        cabinId
        cabinTitleEn
        cabinTitleFr
      }
      categories {
        categoryId
        reasonId
        categoryTitleEn
        categoryTitleFr
        shorthandTxt
        groupIds
        compensation
        cabins {
          cabinId
          shorthandTxt
          compensation
        }
      }
    }
  }
}`;